// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .neuroglancer-layer-side-panel-title {
    display: none;
}

.neuroglancer-layer-side-panel {
    margin-top: 80px;
}

.neuroglancer-minimizable-group-title {
    background-color: var(--color-medium-bg);
    color: var(--color-small-text);
    padding: 8px;
    font-weight: bold;
} */

.neuroglancer-viewer-top-row {
    background-color: var(--color-dark-bg);
    margin-bottom: unset;
}

.ng-extend .overlay-content, .overlay-content.ng-dark {
  /* background-color: var(--color-dark-bg); */
  color: var(--color-small-text);
  border-radius: 10px;
  outline: none;
  min-width: max-content;

  background-color: hsl(0 0% 10% / 1);
  border: 1px solid hsl(0 0% 18% / 1);
}

/*

input.rounded-input {
    outline: none;
}

div.segment-div > * {
    margin: 1px;
}

div.segment-div > .segment-checkbox {
    margin-bottom: 3px;
}

div.segment-div > .segment-color-selector {
    border: none;
    border-color: transparent;
    -webkit-appearance: none;
    background-color: transparent;
    padding: 0;
    margin: 0px;
    height: 23px;
}


.neuroglancer-minimizable-group {
    flex: unset;
}

.nge-segment-management-field-coord {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
  color: #aaa;
  pointer-events: none;
} */
`, "",{"version":3,"sources":["webpack://./src/ng-override.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;GAaG;;AAEH;IACI,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;;EAEtB,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmCG","sourcesContent":["/* .neuroglancer-layer-side-panel-title {\r\n    display: none;\r\n}\r\n\r\n.neuroglancer-layer-side-panel {\r\n    margin-top: 80px;\r\n}\r\n\r\n.neuroglancer-minimizable-group-title {\r\n    background-color: var(--color-medium-bg);\r\n    color: var(--color-small-text);\r\n    padding: 8px;\r\n    font-weight: bold;\r\n} */\r\n\r\n.neuroglancer-viewer-top-row {\r\n    background-color: var(--color-dark-bg);\r\n    margin-bottom: unset;\r\n}\r\n\r\n.ng-extend .overlay-content, .overlay-content.ng-dark {\r\n  /* background-color: var(--color-dark-bg); */\r\n  color: var(--color-small-text);\r\n  border-radius: 10px;\r\n  outline: none;\r\n  min-width: max-content;\r\n\r\n  background-color: hsl(0 0% 10% / 1);\r\n  border: 1px solid hsl(0 0% 18% / 1);\r\n}\r\n\r\n/*\r\n\r\ninput.rounded-input {\r\n    outline: none;\r\n}\r\n\r\ndiv.segment-div > * {\r\n    margin: 1px;\r\n}\r\n\r\ndiv.segment-div > .segment-checkbox {\r\n    margin-bottom: 3px;\r\n}\r\n\r\ndiv.segment-div > .segment-color-selector {\r\n    border: none;\r\n    border-color: transparent;\r\n    -webkit-appearance: none;\r\n    background-color: transparent;\r\n    padding: 0;\r\n    margin: 0px;\r\n    height: 23px;\r\n}\r\n\r\n\r\n.neuroglancer-minimizable-group {\r\n    flex: unset;\r\n}\r\n\r\n.nge-segment-management-field-coord {\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n  box-shadow: none;\r\n  color: #aaa;\r\n  pointer-events: none;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
